import React, { useCallback } from 'react'
import { useAppContext } from '../../containers/App'
import { signOut } from '../../utils/cognito'
import { LinkButton } from 'admin-web-ui'

export const LogoutButton = (): JSX.Element => {
  const { cognitoUser, setCognitoUser } = useAppContext()

  const logout = useCallback(() => {
    if (cognitoUser) {
      signOut({
        cognitoUser,
        onCognitoUserChanged: setCognitoUser,
      })
    }
  }, [cognitoUser, setCognitoUser])

  return (
    <LinkButton className="automation-LogoutButton" onClick={logout}>
      Logout
    </LinkButton>
  )
}
